"use strict";

exports.__esModule = true;
exports.AlertsDataItemChart = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ReactEChartsLineChart = require("../../../Charts/LineChart/ReactEChartsLineChart");
var _downloadSeriesData = require("../../../Charts/LineChart/downloadSeriesData");
var _Time = require("../../../Time");
var _prepareSeriesData = require("../../../Charts/LineChart/prepareSeriesData");
var _DeviceListContext = require("../../../Device/DeviceListContext");
var _date = require("../../../Charts/LineChart/date");
var _Translator = require("../../../Core/Translator");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var AlertsDataItemChart = exports.AlertsDataItemChart = function AlertsDataItemChart(props) {
  var width = props.width,
    height = props.height,
    series = props.series,
    devices = props.devices,
    from = props.from,
    to = props.to;
  var _useContext = (0, _react.useContext)(_Time.TimeContext),
    timezone = _useContext.timezone;
  var deviceList = (0, _react.useContext)(_DeviceListContext.AllDeviceListContext);
  var _useContext2 = (0, _react.useContext)(_Translator.TranslatorContext),
    translate = _useContext2.translate;
  var preparedSeries = (0, _prepareSeriesData.prepareSeries)({
    data: series,
    devices: devices,
    deviceList: deviceList
  });
  var dateFormat = "DD-MM-YYYY";
  var downloadCSVData = function downloadCSVData() {
    return (0, _downloadSeriesData.downloadSeriesData)(preparedSeries, undefined, "Alerts-dataitems-" + (0, _date.formatDate)(from, timezone, dateFormat) + "-" + (0, _date.formatDate)(to, timezone, dateFormat));
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "AlertsDataItemChart.chart"
  }, /*#__PURE__*/_react["default"].createElement(_ReactEChartsLineChart.ReactEChartsLineChart, {
    width: width,
    height: height,
    options: (0, _ReactEChartsLineChart.createEChartProps)(preparedSeries, timezone, translate, downloadCSVData),
    series: preparedSeries,
    timezone: timezone
  }));
};